module.exports = __webpack_public_path__ + "static/media/item-1-10.e1973b6b.svg";